import { PrivateRoutes } from '@/constants/routes'
import { webApiService } from '@/services'
import { currencyFormat } from '@/utils/currencyFormat'
import { Button, Spinner, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@nextui-org/react'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { IoMdInfinite } from 'react-icons/io'
import { useNavigate, useParams } from 'react-router-dom'
import { RiCheckboxCircleFill } from 'react-icons/ri'

const columns = [
  { name: '#', uid: 'target_id' },
  { name: 'Nombre campaña', uid: 'campaign_name' },
  { name: 'Tipo', uid: 'scope' },
  { name: 'Fecha inicio', uid: 'start_date' },
  { name: 'Fecha fín', uid: 'end_date' },
  { name: 'Duración', uid: 'is_infinite' },
  { name: 'Cantidad maxima de Trade-ins', uid: 'max_quantity' },
  { name: 'Monto Máximo', uid: 'amount' },
  { name: 'SBU', uid: 'sbu_name' },
  { name: 'Marca', uid: 'brand_name' },
  { name: 'Modelo', uid: 'model_name' },
  { name: 'Activa', uid: 'active' },
  { name: '', uid: 'actions' }
]
const ListTable = () => {
  const [data, setData] = useState<{ loading: boolean, list: any[] }>({ loading: false, list: [] })
  const { slug } = useParams<{ slug: string }>()
  const navigate = useNavigate()
  const renderCell: any = (item: any, columnKey: any) => {
    const cellValue = item[columnKey]

    /* eslint default-case: "error" */
    switch (columnKey) {
      case 'active':
        return cellValue === 1 ? (<div className='text-green-500 rounded-full w-8 h-8 mx-auto flex items-center justify-center'><RiCheckboxCircleFill size={24} /></div>) : null
      case 'is_infinite':
        return cellValue === 1 ? (<div className='bg-blue-400 text-white rounded-full w-8 h-8 mx-auto flex items-center justify-center'><IoMdInfinite size={24} /></div>) : null
      case 'start_date':
        return moment.utc(cellValue).format('DD/MM/YYYY')
      case 'end_date':
        return cellValue !== null ? moment.utc(cellValue).format('DD/MM/YYYY') : ''
      case 'amount':
        return (<span className='font-bold text-xs'>{currencyFormat(Number(cellValue), import.meta.env.VITE_COUNTRY)}</span>)
      case 'actions':
        return (<Button variant='solid' color='secondary' size='sm' onPress={() => { navigate(PrivateRoutes.CONTRIBUTION.replace(':slug', String(slug)).replace(':id', item.target_id)) }}>Editar</Button>)
      default:
        return (<span className='text-xs'>{cellValue}</span>)
    }
  }

  const loadData = async () => {
    setData({ ...data, loading: true })
    await webApiService.getAllContributions(String(slug)).then((response) => {
      console.log('🚀 ~ loadData ~ response:', response)
      setData({ loading: false, list: response.data })
    })
  }

  useEffect(() => {
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Table
      aria-label='Example table with client side sorting'
      bottomContentPlacement='outside'
    >
      <TableHeader columns={columns.filter(e => e.uid !== 'serie' && e.uid !== 'cancel_reason')}>
        {(column) => (
          <TableColumn key={column.uid} align={column.uid === 'actions' ? 'center' : 'start'} allowsSorting={column.uid !== 'actions'} className={column.uid === 'nombre' || column.uid === 'actions' || column.uid === 'ordenCompraCodigo' ? '' : 'md:table-cell'}>
            {column.name}
          </TableColumn>
        )}
      </TableHeader>
      <TableBody
        isLoading={data.loading}
        loadingContent={<Spinner label='Loading...' />}
      >
        {
            data.list.map((item: any) => (
              <TableRow key={item.target_id}>
                {(columnKey) => <TableCell>{renderCell(item, columnKey)}</TableCell>}
              </TableRow>
            ))
          }
      </TableBody>
    </Table>
  )
}

export default ListTable
